export class PaginationModel {
    page: number;
    records: number;
    total_records: number;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/api/entity/pagination.ts